module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ftit"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("Abbreviations and Glossary")]), _vm._v(" "), _c('p', {
    staticClass: "glosb"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Relating to the United Kingdom unless otherwise indicated")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo1",
      "id": "B_glo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abwehr")])]), _vm._v(" "), _c('td', [_vm._v("German Military Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ACSS")]), _vm._v(" "), _c('td', [_vm._v("Assistant Chief of the Secret [Intelligence] Service")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo2",
      "id": "B_glo2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADM")])]), _vm._v(" "), _c('td', [_vm._v("Admiralty")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Axis")]), _vm._v(" "), _c('td', [_vm._v("Association of Germany and Italy")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#A_glo3",
      "id": "B_glo3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BBC")])]), _vm._v(" "), _c('td', [_vm._v("British Broadcasting Corporation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Berkeley St")]), _vm._v(" "), _c('td', [_vm._v("London-based unit for breaking diplomatic codes")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BJ")]), _vm._v(" "), _c('td', [_vm._v("‘Black Jumbo’, a translated decrypt of an intercepted diplomatic wireless message")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#A_glo4",
      "id": "B_glo4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broederbond")])]), _vm._v(" "), _c('td', [_vm._v("Anti-British organisation in Union of South Africa")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo5",
      "id": "B_glo5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C")])]), _vm._v(" "), _c('td', [_vm._v("Letter denoting either the Chief of the Secret Intelligence Service or the Service itself")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo5a",
      "id": "B_glo5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camp 020")])]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#B_glo28"
    }
  }, [_vm._v("MI5")]), _vm._v(" centre for interrogating foreign nationals")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3a#A_glo6",
      "id": "B_glo6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CBE")])]), _vm._v(" "), _c('td', [_vm._v("Companion of the order of the British Empire")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#A_glo7",
      "id": "B_glo7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CD")])]), _vm._v(" "), _c('td', [_vm._v("Letters denoting the executive head of the Special Operations Executive")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CE")]), _vm._v(" "), _c('td', [_vm._v("Counter Espionage")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#A_glo8",
      "id": "B_glo8"
    }
  }, [_vm._v("CIA")])]), _vm._v(" "), _c('td', [_vm._v("Central Intelligence Agency [USA]")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("C in C")]), _vm._v(" "), _c('td', [_vm._v("Commander in Chief")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter2#A_glo9",
      "id": "B_glo9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COS")])]), _vm._v(" "), _c('td', [_vm._v("Chiefs of Staff")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cossac")]), _vm._v(" "), _c('td', [_vm._v("Chief of Staff to the Supreme Allied Commander")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CSDIC")]), _vm._v(" "), _c('td', [_vm._v("Combined Services Detailed Interrogation Centre")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Endnotesa#A_glo10",
      "id": "B_glo10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CSS")])]), _vm._v(" "), _c('td', [_vm._v("Chief of the Secret [Intelligence] Service")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo11",
      "id": "B_glo11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DBFPFS")])]), _vm._v(" "), _c('td', [_vm._v("Documents on British Foreign Policy first series")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DCSS")]), _vm._v(" "), _c('td', [_vm._v("Deputy Chief of the Secret [Intelligence] Service")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6a#A_glo12",
      "id": "B_glo12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diabolo")])]), _vm._v(" "), _c('td', [_vm._v("Masterman’s plan to publish his "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#B_glo48",
      "id": "A_glo48"
    }
  }, [_vm._v("XX")]), _vm._v(" book in the USA")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#A_glo13",
      "id": "B_glo13"
    }
  }, [_vm._v("DSO")])]), _vm._v(" "), _c('td', [_vm._v("Distinguished Service Order")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Enigma")]), _vm._v(" "), _c('td', [_vm._v("German coding machine")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("FBI")]), _vm._v(" "), _c('td', [_vm._v("Federal Bureau of Investigation [USA]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#A_glo14",
      "id": "B_glo14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Felix")])])]), _vm._v(" "), _c('td', [_vm._v("Lothar Sittig, the principal Nazi spy in South Africa")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo15",
      "id": "B_glo15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FO")])]), _vm._v(" "), _c('td', [_vm._v("Foreign Office")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#A_glo15a",
      "id": "B_glo15a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GC & CS")])]), _vm._v(" "), _c('td', [_vm._v("Government Code and Cypher School with responsibility for devising British codes and breaking foreign ones")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#A_glo16",
      "id": "B_glo16"
    }
  }, [_vm._v("GHQ")])]), _vm._v(" "), _c('td', [_vm._v("General Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Endnotes#A_glo16a",
      "id": "B_glo16a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOC in C")])]), _vm._v(" "), _c('td', [_vm._v("General Officer Commanding in Chief")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#A_glo17",
      "id": "B_glo17"
    }
  }, [_vm._v("GSO")])]), _vm._v(" "), _c('td', [_vm._v("General Staff Officer")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#A_glo18",
      "id": "B_glo18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HMG")])]), _vm._v(" "), _c('td', [_vm._v("His/Her Majesty’s Government")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Humint")]), _vm._v(" "), _c('td', [_vm._v("Intelligence from human sources")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5a#A_glo19",
      "id": "B_glo19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISBA")])]), _vm._v(" "), _c('td', [_vm._v("Intelligence Service British Agents: decrypted and translated German spy messages with restricted circulation as they referred to "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#B_glo40",
      "id": "A_glo40"
    }
  }, [_vm._v("SIS")]), _vm._v(" agents")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#A_glo20",
      "id": "B_glo20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISK")])]), _vm._v(" "), _c('td', [_vm._v("Intelligence Service Knox: decrypted and translated German spy messages originally enciphered with an enigma machine")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#A_glo21",
      "id": "B_glo21"
    }
  }, [_vm._v("ISOS")])]), _vm._v(" "), _c('td', [_vm._v("Intelligence Service Oliver Strachey: decrypted and translated German spy messages originally enciphered manually, eg with a code book.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Endnotes#A_glo22",
      "id": "B_glo22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IWM")])]), _vm._v(" "), _c('td', [_vm._v("Imperial War Museum")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JIC")]), _vm._v(" "), _c('td', [_vm._v("Joint Intelligence Sub-Committee")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#A_glo23",
      "id": "B_glo23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("K")])]), _vm._v(" "), _c('td', [_vm._v("Knighthood")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KCL")]), _vm._v(" "), _c('td', [_vm._v("King’s College London")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo24",
      "id": "B_glo24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KGB")])]), _vm._v(" "), _c('td', [_vm._v("Soviet security and intelligence agency")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#A_glo25",
      "id": "B_glo25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leo")])])]), _vm._v(" "), _c('td', [_vm._v("Basil Batos, a Greek journalist and Nazi spy in southern Africa")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4a#A_glo26",
      "id": "B_glo26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LM")])]), _vm._v(" "), _c('td', [_vm._v("Lourenço Marques, now Maputo, capital of Mozambique")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3a#A_glo27",
      "id": "B_glo27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MBE")])]), _vm._v(" "), _c('td', [_vm._v("Member of the Order of the British Empire")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements#A_glo28",
      "id": "B_glo28"
    }
  }, [_vm._v("MI5")])]), _vm._v(" "), _c('td', [_vm._v("Security Service: agency responsible for preventing espionage, sabotage and subversion on British territory")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#A_glo29",
      "id": "B_glo29"
    }
  }, [_vm._v("MI6")])]), _vm._v(" "), _c('td', [_vm._v("Popular name for Secret Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#A_glo30",
      "id": "B_glo30"
    }
  }, [_vm._v("MIR")])]), _vm._v(" "), _c('td', [_vm._v("Military Intelligence, Research [War Office]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Endnotes#A_glo31",
      "id": "B_glo31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NA2")])]), _vm._v(" "), _c('td', [_vm._v("United States National Archives at College Park")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OED")]), _vm._v(" "), _c('td', [_vm._v("Oxford English Dictionary")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#A_glo32",
      "id": "B_glo32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OSS")])]), _vm._v(" "), _c('td', [_vm._v("American Office of Strategic Services, precursor of "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#B_glo8",
      "id": "A_glo8"
    }
  }, [_vm._v("CIA")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#A_glo33",
      "id": "B_glo33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ossewabrandwag")])]), _vm._v(" "), _c('td', [_vm._v("Paramilitary organisation in South Africa with Nazi ideology")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("PCO")]), _vm._v(" "), _c('td', [_vm._v("Passport Control Officer")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#A_glo34",
      "id": "B_glo34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PEA")])]), _vm._v(" "), _c('td', [_vm._v("Portuguese East Africa [Mozambique]")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("PS")]), _vm._v(" "), _c('td', [_vm._v("Private Secretary")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#A_glo35",
      "id": "B_glo35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PWE")])]), _vm._v(" "), _c('td', [_vm._v("Political Warfare Executive")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5a#A_glo36",
      "id": "B_glo36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RIS")])]), _vm._v(" "), _c('td', [_vm._v("Radio Intelligence Service: Trevor-Roper’s wireless unit in "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#B_glo40"
    }
  }, [_vm._v("SIS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#A_glo37",
      "id": "B_glo37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RNVR")])]), _vm._v(" "), _c('td', [_vm._v("Royal Navy Volunteer Reserve")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#A_glo38",
      "id": "B_glo38"
    }
  }, [_vm._v("RSS")])]), _vm._v(" "), _c('td', [_vm._v("Radio Security Service: organization for intercepting the wireless messages of foreign intelligence services during the Second World War")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#A_glo39",
      "id": "B_glo39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SD")])]), _vm._v(" "), _c('td', [_vm._v("Sicherheitsdienst: Nazi Party security service within the "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#B_glo42",
      "id": "A_glo42"
    }
  }, [_vm._v("SS")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Section D")]), _vm._v(" "), _c('td', [_vm._v("Secret Intelligence Service sabotage section absorbed by "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#B_glo41"
    }
  }, [_vm._v("SOE")]), _vm._v(" in 1940")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Section V")]), _vm._v(" "), _c('td', [_vm._v("Counter-espionage section of the Secret Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Section IX")]), _vm._v(" "), _c('td', [_vm._v("Anti-Communist section of the Secret Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Security Service")]), _vm._v(" "), _c('td', [_vm._v("Usually known as "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#B_glo28"
    }
  }, [_vm._v("MI5")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SHAEF")]), _vm._v(" "), _c('td', [_vm._v("Supreme Headquarters Allied Expeditionary Force")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sigint")]), _vm._v(" "), _c('td', [_vm._v("Intelligence from the interception and decryption of signals")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#A_glo40",
      "id": "B_glo40"
    }
  }, [_vm._v("SIS")])]), _vm._v(" "), _c('td', [_vm._v("Secret Intelligence Service: responsible for gathering intelligence and counter-intelligence outside British territory")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements#A_glo41",
      "id": "B_glo41"
    }
  }, [_vm._v("SOE")])]), _vm._v(" "), _c('td', [_vm._v("Special Operations Executive: responsible for sabotage, subversion and fomenting resistance overseas")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#A_glo42",
      "id": "B_glo42"
    }
  }, [_vm._v("SS")])]), _vm._v(" "), _c('td', [_vm._v("Schutzstaffel: protection squad of the Nazi Party")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Stefani Agency")]), _vm._v(" "), _c('td', [_vm._v("Propaganda distributor for Italian Ministry of Popular Culture")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo43",
      "id": "B_glo43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TNA")])]), _vm._v(" "), _c('td', [_vm._v("United Kingdom National Archives")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter2#A_glo44",
      "id": "B_glo44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UK")])]), _vm._v(" "), _c('td', [_vm._v("United Kingdom")])]), _vm._v(" "), _c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ultra")])]), _vm._v(" "), _c('td', [_vm._v("Security classification for intelligence derived from decoding German wireless messages enciphered by the enigma machine")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#A_glo45",
      "id": "B_glo45"
    }
  }, [_vm._v("USSR")])]), _vm._v(" "), _c('td', [_vm._v("Union of Soviet Socialist Republics")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VCSS")]), _vm._v(" "), _c('td', [_vm._v("Vice Chief of the Secret [Intelligence] Service")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#A_glo45a",
      "id": "B_glo45a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vw")])]), _vm._v(" "), _c('td', [_vm._v("Wireless sub-section of Section V")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography#A_glo46",
      "id": "B_glo46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WO")])]), _vm._v(" "), _c('td', [_vm._v("War Office")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#A_glo47",
      "id": "B_glo47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W/T")])]), _vm._v(" "), _c('td', [_vm._v("Wireless Transmitter")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations#A_glo48",
      "id": "B_glo48"
    }
  }, [_vm._v("XX")])]), _vm._v(" "), _c('td', [_vm._v("Double cross, roman numerals for twenty")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7650f82a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Abbreviations.vue
// module id = 75
// module chunks = 0